import React from 'react'
import { Controller, Control, FieldPath, FieldValues } from 'react-hook-form'
import { useTheme } from '@react-navigation/native'
import { Switch, SwitchProps, Text } from '@components'
import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

type FormSwitchProps<TFieldValues extends FieldValues> = Omit<SwitchProps, 'onChange'> & {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  title: string
}

export const FormSwitch = <TFieldValues extends FieldValues>({
  control,
  name,
  title,
  left,
  right,
  middle,
}: FormSwitchProps<TFieldValues>) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { name, onChange }, fieldState: { error } }) => (
        <>
          {name && (
            <Text style={styles.title} type="bodySmall" color={theme.colors.lightGrey}>
              {title}
            </Text>
          )}
          <Switch {...{ left, right, middle, onChange }} />
          {error?.message && (
            <Text style={styles.errorMessage} type="microText" color={theme.colors.error}>
              {error.message}
            </Text>
          )}
        </>
      )}
    />
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    title: {
      paddingTop: theme.spacing.xl,
      paddingBottom: theme.spacing.md,
    },
    errorMessage: {
      paddingVertical: theme.spacing.sm,
      paddingLeft: theme.spacing.lg,
    },
  })
